module.exports = __webpack_public_path__ + "static/media/Bar_Icon_01.d93b3fc5.svg";